<template>
  <PageHousing>
    <HOurServices />
  </PageHousing>
</template>

<script>
import PageHousing from "@/components/PageHousing";
import HOurServices from "@/components/HOurServices";

export default {
  components: {
    HOurServices,
    PageHousing,
  },

  metaInfo: {
    title: "HobbsTech - Services",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
};
</script>
